import { Injectable } from '@angular/core';
import { ExercicioService, FuncaoService, GlobalService, OrgaoService, ProgressoService, Relatorio } from 'eddydata-lib';
import { Subject } from 'rxjs';
import { FichaDespesaService } from 'contabil-lib';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BalanceteDespesaSubelementoPorRecursoService {

  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected fichaService: FichaDespesaService,
    protected exercicioService: ExercicioService,
    protected orgaoService: OrgaoService,
    protected progressoService: ProgressoService,
    protected globalService: GlobalService,
    protected funcaoService: FuncaoService
  ) { }

  public async montarBalanceteDespesa(mes: number, exercicioId: number, orgaos: number[], login: any, dtInicio: string, dtFim: string) {
    const parametros: {} = { porExecutora: true };
    if (mes) {
      parametros['mes'] = mes;
    } else {
      parametros['dtInicio'] = dtInicio;
      parametros['dtFim'] = dtFim;
    }

    if (exercicioId) {
      parametros['ano'] = exercicioId;
    }
    parametros['orgaos'] = orgaos.join();

    const ex = await this.exercicioService.obterId(exercicioId).toPromise();

    let titulo = '';
    if (mes) {
      titulo = this.globalService.obterDataBR().monthNames[mes - 1].toLocaleUpperCase() + '/' + ex.ano
    } else {
      let dt = dtInicio.split("-");
      titulo = dt[2] + '/' + dt[1] + '/' + dt[0] + ' à ';
      dt = dtFim.split("-");
      titulo += dt[2] + '/' + dt[1] + '/' + dt[0];
    }

    this.fichaService.balanceteSubelementoDag(parametros)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(async idTransacao => {
        this.progressoService.show(idTransacao, async (retorno) => {
          const dados = retorno[0];
          const dadosConsolidado = retorno[1];
          Relatorio.imprimirPersonalizado('REFERÊNCIA: ' +
            titulo, login.usuario.nome, login.usuario.sobrenome,
            login.orgao.nome, login.brasao,
            await this.balanceteDespesaConteudo(dados, dadosConsolidado),
            'landscape', 'RELATORIOS  AUXILIARES - DAGs',
            {
              linhas: {
                hLineWidth(i, node) {
                  return 1;
                },
                vLineWidth(i) {
                  return 1;
                },
                hLineColor(i) {
                  return 'black';
                },
                paddingLeft(i) {
                  return 3;
                },
                paddingRight(i, node) {
                  return 3;
                }
              }
            }, null, true);
        });
      });
  }

  public async balanceteDespesaConteudo(dados: any[], dadosConsolidado: any[]): Promise<{}[]> {
    const conteudo: {}[] = [
      [{
        text: 'RELATORIOS  AUXILIARES - DAGs',
        colSpan: 10, alignment: 'center', bold: true, fontSize: 11
      },
        '', '', '', '', '', '', '', '', ''],
      [
        { text: 'CÓDIGO', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'DESCRIÇÃO', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'EMPENHADA', alignment: 'center', colSpan: 2, bold: true, fontSize: 7 },
        { text: '' },
        { text: 'PROCESSADA', alignment: 'center', colSpan: 2, bold: true, fontSize: 7 },
        { text: '' },
        { text: 'SALDO', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'PAGAMENTO', alignment: 'center', colSpan: 2, bold: true, fontSize: 7 },
        { text: '' },
        { text: 'DÍVIDA', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 }
      ],
      [
        { text: '' },
        { text: '' },
        { text: 'DO MÊS', alignment: 'center', bold: true, fontSize: 7 },
        { text: 'ACUMULADO', alignment: 'center', bold: true, fontSize: 7 },
        { text: 'DO MÊS', alignment: 'center', bold: true, fontSize: 7 },
        { text: 'ACUMULADO', alignment: 'center', bold: true, fontSize: 7 },
        { text: '' },
        { text: 'DO MÊS', alignment: 'center', bold: true, fontSize: 7 },
        { text: 'ACUMULADO', alignment: 'center', bold: true, fontSize: 7 },
        { text: '' }
      ]
    ];

    // Gera as linhas do recurso e a somatória
    const recursos = this.funcaoService.agrupar(dados, ['r_codigo', 'r_nome'], ['empenhado', 'empenhado_mes', 'liquidado', 'liquidado_mes', 'pago', 'pago_mes', 'total_empenhado']);

    for await (const recurso of recursos) {
      const saldo = +recurso.totalizadores['empenhado'] - +recurso.totalizadores['liquidado'];
      const divida = +recurso.totalizadores['liquidado'] - +recurso.totalizadores['pago'];
      conteudo.push([
        { text: `${this.funcaoService.mascarar('##.##.##', recurso.grupo['r_codigo'])} - ${recurso.grupo['r_nome']}`, colSpan: 2, bold: true, fontSize: 7, },
        { text: '' },
        { text: this.funcaoService.convertToBrNumber(`${recurso.totalizadores['empenhado_mes']}`), bold: true, fontSize: 7, alignment: 'right' },
        { text: this.funcaoService.convertToBrNumber(`${recurso.totalizadores['empenhado']}`), bold: true, fontSize: 7, alignment: 'right' },
        { text: this.funcaoService.convertToBrNumber(`${recurso.totalizadores['liquidado_mes']}`), bold: true, fontSize: 7, alignment: 'right' },
        { text: this.funcaoService.convertToBrNumber(`${recurso.totalizadores['liquidado']}`), bold: true, fontSize: 7, alignment: 'right' },
        { text: this.funcaoService.convertToBrNumber(`${saldo}`), bold: true, fontSize: 7, alignment: 'right' },
        { text: this.funcaoService.convertToBrNumber(`${recurso.totalizadores['pago_mes']}`), bold: true, fontSize: 7, alignment: 'right' },
        { text: this.funcaoService.convertToBrNumber(`${recurso.totalizadores['pago']}`), bold: true, fontSize: 7, alignment: 'right' },
        { text: this.funcaoService.convertToBrNumber(`${divida}`), bold: true, fontSize: 7, alignment: 'right' },
      ]);

      // Gera as linhas do orgão executor e a somatória
      const executoras = this.funcaoService.agrupar(recurso.registros, ['ex_codigo', 'ex_nome'], ['empenhado', 'empenhado_mes', 'liquidado', 'liquidado_mes', 'pago', 'pago_mes', 'total_empenhado']);

      for await (const executora of executoras) {
        const saldo = +executora.totalizadores['empenhado'] - +executora.totalizadores['liquidado']
        const divida = +executora.totalizadores['liquidado'] - +executora.totalizadores['pago']
        conteudo.push([
          { text: `${this.funcaoService.mascarar('##.##.##', executora.grupo['ex_codigo'])} - ${executora.grupo['ex_nome']}`, colSpan: 2, bold: true, fontSize: 7, },
          { text: '' },
          { text: this.funcaoService.convertToBrNumber(`${executora.totalizadores['empenhado_mes']}`), bold: true, fontSize: 7, alignment: 'right' },
          { text: this.funcaoService.convertToBrNumber(`${executora.totalizadores['empenhado']}`), bold: true, fontSize: 7, alignment: 'right' },
          { text: this.funcaoService.convertToBrNumber(`${executora.totalizadores['liquidado_mes']}`), bold: true, fontSize: 7, alignment: 'right' },
          { text: this.funcaoService.convertToBrNumber(`${executora.totalizadores['liquidado']}`), bold: true, fontSize: 7, alignment: 'right' },
          { text: this.funcaoService.convertToBrNumber(`${saldo}`), bold: true, fontSize: 7, alignment: 'right' },
          { text: this.funcaoService.convertToBrNumber(`${executora.totalizadores['pago_mes']}`), bold: true, fontSize: 7, alignment: 'right' },
          { text: this.funcaoService.convertToBrNumber(`${executora.totalizadores['pago']}`), bold: true, fontSize: 7, alignment: 'right' },
          { text: this.funcaoService.convertToBrNumber(`${divida}`), bold: true, fontSize: 7, alignment: 'right' },
        ]);

        // Gera as linhas da despesa e a somatória
        const despesas = this.funcaoService.agrupar(executora.registros, ['de_codigo', 'de_nome'], ['empenhado', 'empenhado_mes', 'liquidado', 'liquidado_mes', 'pago', 'pago_mes', 'total_empenhado']);

        for await (const despesa of despesas) {
          const saldo = +despesa.totalizadores['empenhado'] - +despesa.totalizadores['liquidado'];
          const divida = +despesa.totalizadores['liquidado'] - +despesa.totalizadores['pago'];
          conteudo.push([
            { text: `${this.funcaoService.mascarar('##.##.##', despesa.grupo['de_codigo'])} - ${despesa.grupo['de_nome']}`, colSpan: 2, bold: true, fontSize: 7, },
            { text: '' },
            { text: this.funcaoService.convertToBrNumber(`${despesa.totalizadores['empenhado_mes']}`), bold: true, fontSize: 7, alignment: 'right' },
            { text: this.funcaoService.convertToBrNumber(`${despesa.totalizadores['empenhado']}`), bold: true, fontSize: 7, alignment: 'right' },
            { text: this.funcaoService.convertToBrNumber(`${despesa.totalizadores['liquidado_mes']}`), bold: true, fontSize: 7, alignment: 'right' },
            { text: this.funcaoService.convertToBrNumber(`${despesa.totalizadores['liquidado']}`), bold: true, fontSize: 7, alignment: 'right' },
            { text: this.funcaoService.convertToBrNumber(`${saldo}`), bold: true, fontSize: 7, alignment: 'right' },
            { text: this.funcaoService.convertToBrNumber(`${despesa.totalizadores['pago_mes']}`), bold: true, fontSize: 7, alignment: 'right' },
            { text: this.funcaoService.convertToBrNumber(`${despesa.totalizadores['pago']}`), bold: true, fontSize: 7, alignment: 'right' },
            { text: this.funcaoService.convertToBrNumber(`${divida}`), bold: true, fontSize: 7, alignment: 'right' },
          ]);

          // Gera as linhas do subelemento
          for await (const subelemento of despesa.registros) {
            const saldo = +subelemento['empenhado'] - +subelemento['liquidado'];
            const divida = +subelemento['liquidado'] - +subelemento['pago'];
            conteudo.push([
              { text: `${subelemento['sub_codigo']}`, fontSize: 7, },
              { text: `${subelemento['df_nome']}`, fontSize: 7, },
              { text: this.funcaoService.convertToBrNumber(`${subelemento['empenhado_mes']}`), fontSize: 7, alignment: 'right' },
              { text: this.funcaoService.convertToBrNumber(`${subelemento['empenhado']}`), fontSize: 7, alignment: 'right' },
              { text: this.funcaoService.convertToBrNumber(`${subelemento['liquidado_mes']}`), fontSize: 7, alignment: 'right' },
              { text: this.funcaoService.convertToBrNumber(`${subelemento['liquidado']}`), fontSize: 7, alignment: 'right' },
              { text: this.funcaoService.convertToBrNumber(`${saldo}`), fontSize: 7, alignment: 'right' },
              { text: this.funcaoService.convertToBrNumber(`${subelemento['pago_mes']}`), fontSize: 7, alignment: 'right' },
              { text: this.funcaoService.convertToBrNumber(`${subelemento['pago']}`), fontSize: 7, alignment: 'right' },
              { text: this.funcaoService.convertToBrNumber(`${divida}`), fontSize: 7, alignment: 'right' },
            ]);
          }
        }
      }
    }

    let totalEmpenhoMes = 0
    let totalEmpenho = 0
    let totalLiquidadoMes = 0
    let totalLiquidado = 0
    let totalSaldo = 0
    let totalPagoMes = 0
    let totalPago = 0
    let divida = 0

    for await (const item of dados) {
      totalEmpenhoMes += +item['empenhado_mes']
      totalEmpenho += +item['empenhado']
      totalLiquidadoMes += +item['liquidado_mes']
      totalLiquidado += +item['liquidado']
      totalPagoMes += +item['pago_mes']
      totalPago += +item['pago']
    }
    totalSaldo = totalEmpenho - totalLiquidado
    divida = totalLiquidado - totalPago


    conteudo.push([
      { text: `TOTAL GERAL:`, fontSize: 7, bold: true, colSpan: 2 },
      { text: '' },
      { text: this.funcaoService.convertToBrNumber(totalEmpenhoMes), fontSize: 7, bold: true, alignment: 'right' },
      { text: this.funcaoService.convertToBrNumber(totalEmpenho), fontSize: 7, bold: true, alignment: 'right' },
      { text: this.funcaoService.convertToBrNumber(totalLiquidadoMes), fontSize: 7, bold: true, alignment: 'right' },
      { text: this.funcaoService.convertToBrNumber(totalLiquidado), fontSize: 7, bold: true, alignment: 'right' },
      { text: this.funcaoService.convertToBrNumber(totalSaldo), fontSize: 7, bold: true, alignment: 'right' },
      { text: this.funcaoService.convertToBrNumber(totalPagoMes), fontSize: 7, bold: true, alignment: 'right' },
      { text: this.funcaoService.convertToBrNumber(totalPago), fontSize: 7, bold: true, alignment: 'right' },
      { text: this.funcaoService.convertToBrNumber(divida), fontSize: 7, bold: true, alignment: 'right' },
    ]);

    conteudo.push([
      { text: '', margin: 20, colSpan: 10, border: [false, false, false, false] },
      '', '', '', '', '', '', '', '', ''
    ]);

    conteudo.push([
      { text: `CONSOLIDADO`, fontSize: 10, bold: true, colSpan: 10, alignment: 'center' },
      '', '', '', '', '', '', '', '', ''
    ]);


    // Divide por orgãos 
    const porOrgao = this.funcaoService.agrupar(dadosConsolidado, ['o_codigo', 'o_nome'], ['empenhado', 'empenhado_mes', 'liquidado', 'liquidado_mes', 'pago', 'pago_mes', 'total_empenhado']);

    for await (const orgao of porOrgao) {
      const saldo = +orgao.totalizadores['empenhado'] - +orgao.totalizadores['liquidado']
      const divida = +orgao.totalizadores['liquidado'] - +orgao.totalizadores['pago']
      conteudo.push([
        { text: `${orgao.grupo['o_codigo']} - ${orgao.grupo['o_nome']}`, colSpan: 2, bold: true, fontSize: 9 },
        { text: '' },
        { text: this.funcaoService.convertToBrNumber(`${orgao.totalizadores['empenhado_mes']}`), bold: true, fontSize: 9, alignment: 'right' },
        { text: this.funcaoService.convertToBrNumber(`${orgao.totalizadores['empenhado']}`), bold: true, fontSize: 9, alignment: 'right' },
        { text: this.funcaoService.convertToBrNumber(`${orgao.totalizadores['liquidado_mes']}`), bold: true, fontSize: 9, alignment: 'right' },
        { text: this.funcaoService.convertToBrNumber(`${orgao.totalizadores['liquidado']}`), bold: true, fontSize: 9, alignment: 'right' },
        { text: this.funcaoService.convertToBrNumber(`${saldo}`), bold: true, fontSize: 9, alignment: 'right' },
        { text: this.funcaoService.convertToBrNumber(`${orgao.totalizadores['pago_mes']}`), bold: true, fontSize: 9, alignment: 'right' },
        { text: this.funcaoService.convertToBrNumber(`${orgao.totalizadores['pago']}`), bold: true, fontSize: 9, alignment: 'right' },
        { text: this.funcaoService.convertToBrNumber(`${divida}`), bold: true, fontSize: 9, alignment: 'right' },
      ]);

      // Cria as linhas por despesa
      const despesas = this.funcaoService.agrupar(orgao.registros, ['de_codigo', 'de_nome'], ['empenhado', 'empenhado_mes', 'liquidado', 'liquidado_mes', 'pago', 'pago_mes', 'total_empenhado']);

      for await (const despesa of despesas) {
        const saldo = +despesa.totalizadores['empenhado'] - +despesa.totalizadores['liquidado'];
        const divida = +despesa.totalizadores['liquidado'] - +despesa.totalizadores['pago'];
        conteudo.push([
          { text: `${this.funcaoService.mascarar('##.##.##', despesa.grupo['de_codigo'])} - ${despesa.grupo['de_nome']}`, colSpan: 2, bold: true, fontSize: 7, },
          { text: '' },
          { text: this.funcaoService.convertToBrNumber(`${despesa.totalizadores['empenhado_mes']}`), bold: true, fontSize: 7, alignment: 'right' },
          { text: this.funcaoService.convertToBrNumber(`${despesa.totalizadores['empenhado']}`), bold: true, fontSize: 7, alignment: 'right' },
          { text: this.funcaoService.convertToBrNumber(`${despesa.totalizadores['liquidado_mes']}`), bold: true, fontSize: 7, alignment: 'right' },
          { text: this.funcaoService.convertToBrNumber(`${despesa.totalizadores['liquidado']}`), bold: true, fontSize: 7, alignment: 'right' },
          { text: this.funcaoService.convertToBrNumber(`${saldo}`), bold: true, fontSize: 7, alignment: 'right' },
          { text: this.funcaoService.convertToBrNumber(`${despesa.totalizadores['pago_mes']}`), bold: true, fontSize: 7, alignment: 'right' },
          { text: this.funcaoService.convertToBrNumber(`${despesa.totalizadores['pago']}`), bold: true, fontSize: 7, alignment: 'right' },
          { text: this.funcaoService.convertToBrNumber(`${divida}`), bold: true, fontSize: 7, alignment: 'right' },
        ]);

        // Gera as linhas do subelemento
        for await (const subelemento of despesa.registros) {
          const saldo = +subelemento['empenhado'] - +subelemento['liquidado'];
          const divida = +subelemento['liquidado'] - +subelemento['pago'];
          conteudo.push([
            { text: `${subelemento['sub_codigo']}`, fontSize: 7, },
            { text: `${subelemento['df_nome']}`, fontSize: 7, },
            { text: this.funcaoService.convertToBrNumber(`${subelemento['empenhado_mes']}`), fontSize: 7, alignment: 'right' },
            { text: this.funcaoService.convertToBrNumber(`${subelemento['empenhado']}`), fontSize: 7, alignment: 'right' },
            { text: this.funcaoService.convertToBrNumber(`${subelemento['liquidado_mes']}`), fontSize: 7, alignment: 'right' },
            { text: this.funcaoService.convertToBrNumber(`${subelemento['liquidado']}`), fontSize: 7, alignment: 'right' },
            { text: this.funcaoService.convertToBrNumber(`${saldo}`), fontSize: 7, alignment: 'right' },
            { text: this.funcaoService.convertToBrNumber(`${subelemento['pago_mes']}`), fontSize: 7, alignment: 'right' },
            { text: this.funcaoService.convertToBrNumber(`${subelemento['pago']}`), fontSize: 7, alignment: 'right' },
            { text: this.funcaoService.convertToBrNumber(`${divida}`), fontSize: 7, alignment: 'right' },
          ]);
        }
      }
    }


    let totalEmpenhoMesConsolidado = 0
    let totalEmpenhoConsolidado = 0
    let totalLiquidadoMesConsolidado = 0
    let totalLiquidadoConsolidado = 0
    let totalSaldoConsolidado = 0
    let totalPagoMesConsolidado = 0
    let totalPagoConsolidado = 0
    let dividaConsolidado = 0

    for await (const item of dadosConsolidado) {
      totalEmpenhoMesConsolidado += +item['empenhado_mes']
      totalEmpenhoConsolidado += +item['empenhado']
      totalLiquidadoMesConsolidado += +item['liquidado_mes']
      totalLiquidadoConsolidado += +item['liquidado']
      totalPagoMesConsolidado += +item['pago_mes']
      totalPagoConsolidado += +item['pago']
    }
    totalSaldoConsolidado = totalEmpenhoConsolidado - totalLiquidadoConsolidado
    dividaConsolidado = totalLiquidadoConsolidado - totalPagoConsolidado


    conteudo.push([
      { text: `TOTAL GERAL:`, fontSize: 7, bold: true, colSpan: 2 },
      { text: '' },
      { text: this.funcaoService.convertToBrNumber(totalEmpenhoMesConsolidado), fontSize: 7, bold: true, alignment: 'right' },
      { text: this.funcaoService.convertToBrNumber(totalEmpenhoConsolidado), fontSize: 7, bold: true, alignment: 'right' },
      { text: this.funcaoService.convertToBrNumber(totalLiquidadoMesConsolidado), fontSize: 7, bold: true, alignment: 'right' },
      { text: this.funcaoService.convertToBrNumber(totalLiquidadoConsolidado), fontSize: 7, bold: true, alignment: 'right' },
      { text: this.funcaoService.convertToBrNumber(totalSaldoConsolidado), fontSize: 7, bold: true, alignment: 'right' },
      { text: this.funcaoService.convertToBrNumber(totalPagoMesConsolidado), fontSize: 7, bold: true, alignment: 'right' },
      { text: this.funcaoService.convertToBrNumber(totalPagoConsolidado), fontSize: 7, bold: true, alignment: 'right' },
      { text: this.funcaoService.convertToBrNumber(dividaConsolidado), fontSize: 7, bold: true, alignment: 'right' },
    ]);

    return [
      {
        layout: 'linhas',
        table: {
          dontBreakRows: true,
          headerRows: 3,
          widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
          body: conteudo,
        }
      }
    ];
  }
}
